import moment, { Moment } from "moment";

export function getMinMaxMinutes(
	startOfWeek: Moment,
	times: number[],
	isMin: boolean
): number | null {
	startOfWeek = startOfWeek.clone();
	const endOfWeek = startOfWeek.clone().add(1, "week");
	let result: number | null = null;

	times.forEach((time) => {
		const timeMoment = moment.unix(time);
		const timeMinutes = timeMoment.hour() * 60 + timeMoment.minute();

		if (
			timeMoment.isSameOrAfter(startOfWeek) &&
			timeMoment.isBefore(endOfWeek) &&
			(result === null ||
				(isMin && timeMinutes < result) ||
				(!isMin && timeMinutes > result))
		) {
			result = timeMinutes;
		}
	});

	return result;
}
